import React, { Component } from 'react';
import {
  Button,
  Col,
  Divider,
  Icon,
  Input,
  message,
  Popconfirm,
  Row,
  Spin,
  Table,
  Tabs,
  Tooltip,
} from 'antd';
import { Link } from 'react-router';
import { connect } from 'react-redux';

import util from '@util';
import {
  queryCheckBooksErr,
  queryDeleteFinanceBooks,
  queryFinanceBooksList,
  queryFinanceBooksListStatistics,
  querySaveFinanceBooks,
} from '@api/finance/finance';

import { setBackInfo } from '@store/modules/back_info';
import { saveIncomeInfo } from '@store/modules/income_info';

import { queryDisableCapitalGroup, queryEnableCapitalGroup } from '@api/finance/budget';
import ModalAdd from './ModalAdd';

const { TabPane } = Tabs;

class Index extends Component {
  constructor(props) {
    super(props);
    this.state = {
      total: 0,
      pageSize: 15,
      available: 0,
      currentTotal: 0,
      financeTotle: 0,
      staLoading: false,

      company: [],
      modalAddVisible: false,
      modalEditVisible: false,

      pageNo: 1,
      tabKey: '0',
      condition: '',

      checkErrorLoading: false,
    };
  }

  componentWillMount() {
    const { dispatch } = this.props;
    dispatch(
      saveIncomeInfo({
        isShowPart: true,
        // 2 是走账数据
        isNonBusiness: false,
      }),
    );
  }

  componentDidMount() {
    const {
      backInfo,
      location: { pathname },
    } = this.props;
    if (backInfo.path === pathname) {
      this.setState(
        {
          pageNo: backInfo.pageNo,
          tabKey: backInfo.tabKey,
          condition: backInfo.condition,
        },
        () => {
          this.loadData();
        },
      );
    } else {
      this.loadData();
    }
    this.loadStatisticsData();
  }

  componentWillUnmount() {
    const { pageNo, tabKey, condition } = this.state;
    const params = {};

    params.pageNo = pageNo;
    params.tabKey = tabKey;
    params.condition = condition;
    params.path = this.props.location.pathname;

    this.props.dispatch(setBackInfo(params));
  }

  loadData = pageNo => {
    const params = {};
    const context = this;
    const { pageSize, condition, tabKey } = this.state;
    const no = this.state.pageNo;
    const current = pageNo || no;
    params.type = tabKey;
    params.limit = pageSize;
    params.condition = condition || '';
    params.start = current;

    this.setState({
      pageNo: current,
      isLoading: true,
    });

    queryFinanceBooksList(params).then(res => {
      if (res.statusCode === 200) {
        context.setState({
          isLoading: false,
          total: res.totalSize,
          company: res.data,
        });
      } else {
        message.error(res.message);
      }
    });
  };

  loadStatisticsData() {
    const context = this;
    const { tabKey } = this.state;
    context.setState({
      staLoading: true,
    });
    queryFinanceBooksListStatistics({ type: tabKey }).then(res => {
      if (res.statusCode === 200) {
        context.setState({
          available: res.data.available,
          currentTotal: res.data.currentTotal,
          financeTotle: res.data.financeTotle,
          staLoading: false,
        });
      } else {
        message.error(res.message);
      }
    });
  }

  /**
   * 按条件搜索
   */
  search = () => {
    this.loadData(1);
  };

  delete = uuid => {
    const context = this;
    queryDeleteFinanceBooks(uuid).then(res => {
      if (res.statusCode === 200) {
        context.loadData();
        context.loadStatisticsData();
      } else {
        message.error(res.message);
      }
    });
  };

  /**
   * 显示添加账户弹窗
   */
  showModalAdd = () => {
    this.setState({
      modalAddVisible: true,
    });
  };

  handleCheckAmountErr = () => {
    this.setState({ checkErrorLoading: true });
    queryCheckBooksErr().then(res => {
      if (res.statusCode === 200) {
        this.setState({ checkErrorLoading: false });
        this.loadData();
      }
    });
  };

  /**
   * 显示编辑账户弹窗
   */
  showModalEdit = uuid => {
    this.uuid = uuid;
    this.setState({
      modalEditVisible: true,
    });
  };

  hideModal = () => {
    this.setState({
      modalAddVisible: false,
      modalEditVisible: false,
    });
  };

  /**
   * 新增账号
   */
  handAddSubmit = item => {
    querySaveFinanceBooks(item).then(res => {
      if (res.statusCode === 200) {
        message.success(res.message);
        this.hideModal();
        this.loadData();
        this.loadStatisticsData();
      } else {
        message.error(res.message);
      }
    });
  };

  /**
   * 编辑账号
   */
  handEditSubmit = item => {
    item.uuid = this.uuid;
    querySaveFinanceBooks(item).then(res => {
      if (res.statusCode === 200) {
        message.success(res.message);
        this.hideModal();
        this.loadData();
        this.loadStatisticsData();
      } else {
        message.error(res.message);
      }
    });
  };

  setCondition = e => {
    this.setState({
      condition: e.target.value,
    });
  };

  /**
   * 启用资金账户
   */
  handleEnable = uuid => {
    queryEnableCapitalGroup(uuid).then(res => {
      if (res.statusCode === 200) {
        this.loadData();
        this.loadStatisticsData();
      } else {
        message.error(res.message);
      }
    });
  };

  /**
   * 禁用资金账户
   */
  handleDisable = uuid => {
    queryDisableCapitalGroup(uuid).then(res => {
      if (res.statusCode === 200) {
        this.loadData();
        this.loadStatisticsData();
      } else {
        message.error(res.message);
      }
    });
  };

  callback = key => {
    this.setState(
      {
        tabKey: key,
      },
      () => {
        this.loadData(1);
        this.loadStatisticsData();
      },
    );
  };

  currentBalanceTitle = () => {
    return (
      <span>
        余额（元）
        <Tooltip title="验证公式:初始资金+总收入-总支出=当前余额">
          <Icon type="info-circle" style={{ fontSize: '10px' }} />
        </Tooltip>
      </span>
    );
  };

  formatFloat = f => {
    const m = 10 ** 2;
    return Math.round(f * m) / m;
  };

  columns = () => {
    const { isFinancialM } = this.props;
    const { pageSize } = this.state;
    return [
      {
        title: '序号',
        dataIndex: 'num',
        key: 'num',
        render: (text, record, index) => {
          const tot = pageSize * (this.state.pageNo - 1) + index + 1;
          return <span>{tot}</span>;
        },
      },
      {
        title: '公司名称',
        dataIndex: 'companyName',
        key: 'companyName',
        render: (text, record) => <Link to={`/finance/capital/${record.uuid}/detail`}>{text}</Link>,
      },
      {
        title: '账户名称',
        dataIndex: 'bookName',
        key: 'bookName',
      },
      {
        title: '年初余额（元）',
        dataIndex: 'initBalance',
        key: 'initBalance',
        render: text => <span>{util.numberFormat(text, 2, '.', ',')}</span>,
      },
      {
        title: this.currentBalanceTitle(),
        dataIndex: 'currentBalance',
        key: 'currentBalance',
        render: (text, record) => (
          <span>
            <span>{util.numberFormat(text, 2, '.', ',')}</span>
            {record.isErr === 1 ? <span style={{ color: 'red' }}>!统计有误</span> : ''}
          </span>
        ),
      },
      {
        title: '理财款余额',
        dataIndex: 'financeBalance',
        key: 'financeBalance',
        render: text => util.numberFormat(text, 2, '.', ','),
      },
      {
        title: '摘要',
        dataIndex: 'remark',
        key: 'remark',
        width: '25%',
      },
      {
        title: '操作',
        key: 'done',
        render: (text, record) => {
          if (isFinancialM) {
            return (
              <span>
                {record.isEnable === 0 ? (
                  <Popconfirm
                    placement="leftTop"
                    title="确定启用此资金账户吗？"
                    onConfirm={() => this.handleEnable(record.uuid)}
                    okText="确定"
                    cancelText="取消"
                  >
                    <a>启用</a>
                  </Popconfirm>
                ) : (
                  <span>
                    <Popconfirm
                      placement="leftTop"
                      title="确定禁用此资金账户吗？"
                      onConfirm={() => this.handleDisable(record.uuid)}
                      okText="确定"
                      cancelText="取消"
                    >
                      <a>禁用</a>
                    </Popconfirm>

                    <Divider type="vertical" />

                    <Link to={`/finance/capital/${record.uuid}/detail`}>详情</Link>

                    <Divider type="vertical" />

                    <a onClick={() => this.showModalEdit(record.uuid)}>编辑</a>

                    {isFinancialM ? (
                      <span>
                        <Divider type="vertical" />
                        <a onClick={() => this.toYearStatic(record)}>查看统计</a>
                      </span>
                    ) : null}
                  </span>
                )}
              </span>
            );
          }
          return <Link to={`/finance/capital/${record.uuid}/detail`}>详情</Link>;
        },
      },
    ];
  };

  /**
   * 跳转至按年统计详情页
   */
  toYearStatic = bookInfo => {
    this.props.router.push({
      pathname: `/finance/statis/${bookInfo.uuid}/year`,
      query: {
        companyName: bookInfo.companyName,
      },
    });
  };

  render() {
    const {
      total,
      tabKey,
      pageNo,
      company,
      pageSize,
      isLoading,
      staLoading,
      available,
      currentTotal,
      financeTotle,
    } = this.state;
    const pagination = {
      pageSize,
      total,
      current: pageNo,
      showSizeChanger: false,
      onChange: current => {
        this.loadData(current);
      },
      showTotal: showTotal => {
        return `共 ${showTotal} 条`;
      },
    };
    const { isFinancialM } = this.props;

    return (
      <div>
        <div style={{ minWidth: '800px' }}>
          <Row type="flex" justify="space-between" style={{ marginBottom: '16px' }}>
            <Col style={{ lineHeight: '32px' }}>
              {isFinancialM ? (
                <Button icon="plus" style={{ marginRight: '10px' }} onClick={this.showModalAdd}>
                  添加
                </Button>
              ) : (
                ''
              )}
              {isFinancialM ? (
                <Button
                  style={{ marginRight: '10px' }}
                  onClick={this.handleCheckAmountErr}
                  loading={this.state.checkErrorLoading}
                >
                  检查统计
                </Button>
              ) : (
                ''
              )}
              <span>
                银行余额:{staLoading ? <Spin /> : util.numberFormat(currentTotal, 2, '.', ',')}元
              </span>
              <span style={{ marginLeft: '10px' }}>
                理财款余额: {staLoading ? <Spin /> : util.numberFormat(financeTotle, 2, '.', ',')}元
              </span>
              <span style={{ marginLeft: '10px' }}>
                可用余额: {staLoading ? <Spin /> : util.numberFormat(available, 2, '.', ',')}元
              </span>
            </Col>
            <Col style={{ textAlign: 'right' }}>
              <Input
                placeholder="请输入关键字"
                style={{ width: '300px' }}
                value={this.state.condition}
                onChange={this.setCondition}
              />
              <Button type="primary" style={{ marginLeft: '10px' }} onClick={this.search}>
                搜索
              </Button>
            </Col>
          </Row>
        </div>

        <div>
          <Tabs activeKey={tabKey} onChange={this.callback}>
            <TabPane tab="体系内" key="0">
              <Table
                rowKey={record => record.uuid}
                rowSelection={{}}
                columns={this.columns()}
                dataSource={company}
                pagination={pagination}
                loading={isLoading}
              />
            </TabPane>

            {isFinancialM ? (
              <TabPane tab="体系外" key="1">
                <Table
                  rowKey={record => record.uuid}
                  rowSelection={{}}
                  columns={this.columns()}
                  dataSource={company}
                  pagination={pagination}
                  loading={isLoading}
                />
              </TabPane>
            ) : (
              <TabPane tab="体系外" disable key="1" />
            )}
          </Tabs>
        </div>

        {this.state.modalAddVisible ? (
          <ModalAdd handSubmit={this.handAddSubmit} data={{}} cancel={this.hideModal} />
        ) : (
          ''
        )}
        {this.state.modalEditVisible ? (
          <ModalAdd
            handSubmit={this.handEditSubmit}
            data={{}}
            uuid={this.uuid}
            cancel={this.hideModal}
          />
        ) : (
          ''
        )}
      </div>
    );
  }
}

export default connect(state => ({
  backInfo: state.back_info,
  isFinancialM: state.account_info.isFinancialM,
}))(Index);



// WEBPACK FOOTER //
// ./src/components/finance/capital/Index.js